<template>
  <div>
    <b-card>
      <b-card-body v-if="ready" class="p-1">
        <div class="clearfix">
          <div class="float-end">
            <div class="input-group input-group-sm">
              <select class="form-select form-select-sm" v-model="duration" @change="handleSelection">
                <option value="day" selected>{{ $t('pages.dashboard.email_statistics.daily') }}</option>
                <option value="week" selected>{{ $t('pages.dashboard.email_statistics.weekly') }}</option>
                <option value="month">{{ $t('pages.dashboard.email_statistics.monthly') }}</option>
              </select>
            </div>
          </div>
          <h4 class="card-title mb-4">{{ $t('pages.dashboard.email_statistics.title') }}
            <span class="text-muted">({{ $t('pages.dashboard.email_statistics.last_days', {days: this.date}) }})</span>
          </h4>
        </div>

        <apexchart
            :key="statistics.id"
            class="apex-charts"
            dir="ltr"
            height="485"
            type="bar"
            :series="series"
            :options="chartOptions"
        ></apexchart>

      </b-card-body>
      <b-card-body v-else>
        <chart-skeleton :height="525"/>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>

import ChartSkeleton from "../../../components/Skeletons/ChartSkeleton";
import ReviewStatMixin from "../../../mixins/ReviewStatMixin";

export default {
  name: 'EmailStatistics',
  components: {ChartSkeleton},
  mixins: [ReviewStatMixin],
  props: ['statistics', 'date'],
  data() {
    return {
      ready: false,
      series: [],
      chartOptions: {
        xaxis: {
          type: 'datetime',
          categories: [],
        },
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        dataLabels: {
          enabled: false
        },
        colors: ['#34c38f','#f46a6a','#556ee6'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '45%',
            endingShape: 'rounded'
          },
        },
        grid: {
          borderColor: '#f1f1f1',
        },
        fill: {
          opacity: 1
        },
        yaxis: {
          title: {
            text: this.$t('pages.dashboard.email_statistics.count'),
            style: {
              fontWeight: '500',
            },
          },
        },
        tooltip: {
          x: {
            formatter: val => {
              return this.tooltipFormatter(val)
            }
          }
        },
      }
    }
  },
  watch: {
    'statistics.data'() {
      this.calculateChartData()
    }
  },
  methods: {
    async handleSelection() {
      this.ready = false
      await this.calculateChartData()
      this.ready = true
    },
    async calculateChartData() {
      this.ready = false

      const chartData = await this.groupAndBuild(this.statistics.data, this.duration, this.duration)
      const email = [], reviews = [], feedbacks = []
      const categories = []

      chartData.map(x => {
        categories.push(x[this.duration])

        email.push(x.value['email'])
        reviews.push(x.value['review'])
        feedbacks.push(x.value['feedback'])
      })

      this.series = [
        {name: this.$t('pages.dashboard.email_statistics.sent'), data: email},
        {name: this.$t('pages.dashboard.email_statistics.feedbacks'), data: feedbacks},
        {name: this.$t('pages.dashboard.email_statistics.reviews'), data: reviews},
      ]

      this.chartOptions.xaxis.categories = categories

      this.ready = true
    }
  }
};
</script>
